/** Structure of a legal document shown on the static pages. Inline `**bold**` and 【placeholders】 are marked up by the renderer. */

export const LegalDocId = { Privacy: 'privacy', Terms: 'terms' } as const;
export type LegalDocId = (typeof LegalDocId)[keyof typeof LegalDocId];

export const LegalBlockKind = { Paragraph: 'p', List: 'list', Table: 'table' } as const;

export type LegalBlock =
  | { readonly kind: typeof LegalBlockKind.Paragraph; readonly text: string }
  | { readonly kind: typeof LegalBlockKind.List; readonly items: readonly string[] }
  | {
      readonly kind: typeof LegalBlockKind.Table;
      readonly head: readonly string[];
      readonly rows: readonly (readonly string[])[];
    };

export interface LegalSection {
  readonly heading: string;
  readonly blocks: readonly LegalBlock[];
}

export interface LegalDocument {
  readonly title: string;
  /** The draft notice under the title. */
  readonly draftNote: string;
  /** Operator, contact and effective date lines. */
  readonly meta: readonly string[];
  readonly sections: readonly LegalSection[];
}

/** Text between 【 and 】: items the operator still has to supply or confirm (docs/legal/*.md). */
export const PLACEHOLDER_PATTERN = /【[^】]*】/g;

const P = (text: string): LegalBlock => ({ kind: LegalBlockKind.Paragraph, text });
const L = (...items: string[]): LegalBlock => ({ kind: LegalBlockKind.List, items });
export const legalParagraph = P;
export const legalList = L;
